import React from 'react';
import { howItWorksSteps } from '../../data/mockData';
import { UserPlus, Search, Calendar, GraduationCap } from 'lucide-react';

const iconMap = {
  UserPlus,
  Search,
  Calendar,
  GraduationCap
};

export const HowItWorks = () => {
  return (
    <div className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Get started with Avyudha in four simple steps
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {howItWorksSteps.map((step, index) => {
            const Icon = iconMap[step.icon];
            return (
              <div key={step.id} className="relative">
                {/* Connector Line - Hidden on mobile, shown on desktop */}
                {index < howItWorksSteps.length - 1 && (
                  <div className="hidden lg:block absolute top-12 left-full w-full h-0.5 bg-blue-200 -translate-x-1/2 z-0"></div>
                )}
                
                <div className="relative bg-gradient-to-br from-blue-50 to-white p-6 rounded-xl border-2 border-blue-100 hover:border-blue-300 transition-all hover:shadow-lg">
                  {/* Step Number */}
                  <div className="absolute -top-4 -left-4 bg-blue-600 text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg shadow-lg">
                    {step.id}
                  </div>

                  {/* Icon */}
                  <div className="bg-blue-600 w-16 h-16 rounded-lg flex items-center justify-center mb-4">
                    <Icon className="h-8 w-8 text-white" />
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {step.title}
                  </h3>
                  <p className="text-gray-600">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Image Section */}
        <div className="mt-16">
          <img
            src="https://images.unsplash.com/photo-1501504905252-473c47e087f8"
            alt="Learning Process"
            className="w-full h-64 object-cover rounded-2xl shadow-lg"
          />
        </div>
      </div>
    </div>
  );
};
